import setupSentry from "@/v2/sentry"
import { Controller } from "@hotwired/stimulus"
import { createPinia } from "pinia"
import { type App, type Component, createApp } from "vue"
import LocationComboBox from "@/v2/vue/combobox/LocationComboBox.vue"
import PositionTitleComboBox from "@/v2/vue/combobox/PositionTitleComboBox.vue"
import SimilarTitleComboBox from "@/v2/vue/combobox/SimilarTitleComboBox.vue"
import SkillComboBox from "@/v2/vue/combobox/SkillComboBox.vue"

// Components ERB mounts through the `vue_component` helper. Each mount point
// is its own app fed by JSON props, so the runtime-only Vue build suffices.
const components: Record<string, Component> = {
  LocationComboBox,
  PositionTitleComboBox,
  SimilarTitleComboBox,
  SkillComboBox,
}

export default class extends Controller<HTMLElement> {
  static values = {
    component: String,
    props: { type: Object, default: {} },
  }

  declare readonly componentValue: string
  declare readonly propsValue: Record<string, unknown>

  private app?: App

  connect(): void {
    const component = components[this.componentValue]
    if (!component) throw new Error(`Unknown Vue component: ${this.componentValue}`)

    this.app = createApp(component, this.propsValue)

    if (!this.isLocal()) {
      setupSentry(this.app, this.environment)
    }

    this.app.use(createPinia())
    this.app.mount(this.element)
  }

  disconnect(): void {
    this.app?.unmount()
    this.app = undefined
  }

  private isLocal(): boolean {
    return this.environment === "development" || this.environment === "test"
  }

  private get environment(): string {
    return import.meta.env.MODE
  }
}
